import { type Theme } from '@mui/material';

export const resolveColor = (theme: Theme, color: string) => {
    const [variant, token = 'main'] = color.split('.');

    // @ts-expect-error TS2538 Issue #4120
    return (theme.palette[variant]?.[token] || theme.fixed[variant]?.[token]) ?? color;
};
